
function closedropdowns()
  {
    document.querySelectorAll('.accordionHeader.active').forEach((details)=>{ 
            details.classList.remove("active");        
});
 document.querySelectorAll('.accordionPanel').forEach((summary)=>{ 
            summary.style.maxHeight = null;
 }); 

    document.querySelectorAll('.accordionHeader2.active').forEach((details)=>{ 
            details.classList.remove("active");        
});
 document.querySelectorAll('.accordionPanel2').forEach((summary)=>{ 
            summary.style.maxHeight = null;
 }); 
  }




class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.timer = null; 
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener(
      'mouseover',
      this.onSummaryHover.bind(this)
    );
   
    document.body.addEventListener(
      'mouseover',
      this.onSummaryHoverOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }
  closeOthers(event) {
     var inputsObj  =document.querySelectorAll("header-menu");
     //inputsObj = customElements.get("header-menu")
     //console.log(inputsObj)
     for(var i = 0; i<inputsObj.length;i++){
       if(inputsObj[i] !== event.target.closest('header-menu')){
       	inputsObj[i].querySelector("details").removeAttribute('open');
        inputsObj[i].querySelector('summary').setAttribute('aria-expanded', false);
       }
     }
   
  }
  onBodyOutEvent(event){

    var open_detail = document.querySelector(".menu_new details[open='open']").closest("details");
    open_detail.removeAttribute('open');
    open_detail.querySelector('summary').nextElementSibling.setAttribute('aria-expanded', false);

    closedropdowns()
  }
  onSummaryHoverOut(event){
     clearTimeout(this.timer);
   if((event.target.closest('header-menu') && event.target.closest('header-menu').classList.contains('menu_new')) || event.target.classList.contains("mega-menu__content")){
    
     
    }
    else{
      
        this.timer = setTimeout(function(){
          var elem = document.querySelector(".menu_new details[open='open']");
          if(elem){
            var open_detail = elem.closest("details");
            open_detail.removeAttribute('open');
            open_detail.querySelector('summary').nextElementSibling.setAttribute('aria-expanded', false);

             if(document.querySelector("#MainContent"))
               document.querySelector("#MainContent").classList.remove('OverlayBackgroundMega');

            
            closedropdowns(); 
          }
            
        }, 200);
     
    }
  }
   onSummaryHover(event) {
	clearTimeout(this.timer);
    event.preventDefault();
    if(event.target.closest('header-menu').classList.contains('menu_new')){
      	//event.target.closest('header-menu').classList.add("Yoo")
    	this.open(event);
    }
  }
  
  open(event){
     
      this.closeOthers(event);
      this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
      this.mainDetailsToggle.setAttribute('open','open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      //document.body.addEventListener('mouseover', this.onBodyOutEvent);
     if(document.querySelector("#MainContent"))
       document.querySelector("#MainContent").classList.add('OverlayBackgroundMega');
  }
  
  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false); 
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);



function closeMegaMenu()
  {
          var elem = document.querySelector(".menu_new details[open='open']");
          if(elem){
            var open_detail = elem.closest("details");
            open_detail.removeAttribute('open');
            open_detail.querySelector('summary').nextElementSibling.setAttribute('aria-expanded', false);

             if(document.querySelector("#MainContent"))
               document.querySelector("#MainContent").classList.remove('OverlayBackgroundMega');
            
          }

closedropdowns();
    
  }


/*
document.addEventListener('wheel', (event) => {closeMegaMenu()});
*/
